<template>
    <div class="change-date">
        <button type="button" class="close ml-auto mb-1" @click="$emit('close')">×</button>
        <h5>La fecha de entrega ha cambiado a:</h5>
        <p class="mb-0">{{ dateFormatted }}</p>
    </div>
</template>

<script>
    export default {
        name: "ChangedDateVariety",
        props: {
            date: {
                type: Date,
            }
        },
        computed: {
            dateFormatted() {
                return moment(this.date).format('dddd D [de] MMMM YYYY');
            }
        }
    }
</script>

<style scoped>
    .change-date {
        background-color: #c2282d;
        color: white;
        margin-top: 2em;
        padding: 2.5em 1em;
    }

    button.close {
        margin-top: -1em;
        color: #fff;
        opacity: 1;
    }
</style>
